const thematic1 = [
  {
    "id": 22,
    "date": "2022-09-04T19:12:25",
    "date_gmt": "2022-09-04T19:12:25",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/?p=22"
    },
    "modified": "2022-09-13T13:19:35",
    "modified_gmt": "2022-09-13T13:19:35",
    "slug": "how-to-integrate-singaporeans-into-china-using-tea-culture",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/2022/09/04/how-to-integrate-singaporeans-into-china-using-tea-culture/",
    "title": {
      "rendered": "How to Integrate Singaporeans into China using Tea Culture"
    },
    "content": {
      "rendered": "\u003Cdiv class=\"page\" title=\"Page 4\"\u003E\n\u003Cdiv class=\"section\"\u003E\n\u003Cdiv class=\"layoutArea\"\u003E\n\u003Cdiv class=\"column\"\u003E\n\u003Cp\u003E\u003Cstrong\u003EModule:\u003C/strong\u003E RVC1000 How in the world do we get along?\u003Cbr /\u003E\n\u003Cstrong\u003EPresenters:\u003C/strong\u003E Chua Yu Xuan Richeton/ Lee Wen Xiong/ Ryan Qiu Jingxuan/ Wang Jian Ann Howard\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAbstract:\u003Cbr /\u003E\n\u003C/strong\u003ETea culture encompasses how tea is made and consumed, and the interaction among people with tea at tea houses. In business, tea drinking provides a platform for employees to understand each other better. This strengthens the social bond among them and allows them to forge better working relationships with one another. Specifically, the project will cover the integration of Singaporeans into China using tea culture. In China, tea embodies culture, which is a symbol of respect, apology and gratitude. This is applicable in the workplace &#8211; by serving tea to the seniors and guests first, one is displaying courtesy and showing respect for hierarchy. In addition, the project will showcase the connection between China workplace practices and tea culture, to allow one to understand ways to connect with others in a cross-cultural setting and improve relationships with others.\u003C/p\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EModule: RVC1000 How in the world do we get along? Presenters: Chua Yu Xuan Richeton/ Lee Wen Xiong/ Ryan Qiu Jingxuan/ Wang Jian Ann Howard Abstract: Tea culture encompasses how tea is made and consumed, and the interaction among people with tea at tea houses. In business, tea drinking provides a platform for employees to [&hellip;]\u003C/p\u003E\n",
      "protected": false
    },
    "author": 32564,
    "featured_media": 0,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "footnotes": ""
    },
    "categories": [1],
    "tags": [],
    "class_list": [
      "post-22",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-uncategorized"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/22",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/users/32564"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/comments?post=22"
        }
      ],
      "version-history": [
        {
          "count": 2,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/22/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 25,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/22/revisions/25"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/media?parent=22"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/categories?post=22"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/tags?post=22"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 14,
    "date": "2022-09-04T19:10:44",
    "date_gmt": "2022-09-04T19:10:44",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/?p=14"
    },
    "modified": "2022-09-04T19:11:48",
    "modified_gmt": "2022-09-04T19:11:48",
    "slug": "zen-and-emotional-intelligence-in-the-workplace",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/2022/09/04/zen-and-emotional-intelligence-in-the-workplace/",
    "title": {
      "rendered": "Zen and Emotional Intelligence in the Workplace"
    },
    "content": {
      "rendered": "\u003Cdiv class=\"page\" title=\"Page 3\"\u003E\n\u003Cdiv class=\"section\"\u003E\n\u003Cdiv class=\"layoutArea\"\u003E\n\u003Cdiv class=\"column\"\u003E\n\u003Cp\u003E\u003Cstrong\u003EModule:\u003C/strong\u003E RVC1000 How in the world do we get along?\u003Cbr /\u003E\n\u003Cstrong\u003EPresenters:\u003C/strong\u003E Ayumi Angel Fukuyasu Lim/ Liew Weng Yi/ Nathan Choo En Xi/ Sieng Chun Hon\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAbstract:\u003Cbr /\u003E\n\u003C/strong\u003EDressed up in a suit and tie, Yohei, a hotel receptionist, was sweeping the pedestrian walkway right outside the hotel where he works, bright and early in the morning at 7am. With a broad smile on his face, he waved at pedestrians who walked by and greeted them. This is one of the scenes from the series “Day in the life of a Japanese worker” by Youtuber Paolo from Tokyo. Despite being perceived as one of the most stressful cities in the world, their motivation and passion to work is one that is apparent to all. In other words, “stress” is not the word that comes to mind when you see these people working. Our group wanted to find out more about the secret behind this motivation and passion that is evident even amidst a stressful environment &#8211; Zen.\u003C/p\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EModule: RVC1000 How in the world do we get along? Presenters: Ayumi Angel Fukuyasu Lim/ Liew Weng Yi/ Nathan Choo En Xi/ Sieng Chun Hon Abstract: Dressed up in a suit and tie, Yohei, a hotel receptionist, was sweeping the pedestrian walkway right outside the hotel where he works, bright and early in the morning [&hellip;]\u003C/p\u003E\n",
      "protected": false
    },
    "author": 32564,
    "featured_media": 0,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "footnotes": ""
    },
    "categories": [1],
    "tags": [],
    "class_list": [
      "post-14",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-uncategorized"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/14",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/users/32564"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/comments?post=14"
        }
      ],
      "version-history": [
        {
          "count": 2,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/14/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 21,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/14/revisions/21"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/media?parent=14"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/categories?post=14"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/tags?post=14"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 12,
    "date": "2022-09-04T19:10:10",
    "date_gmt": "2022-09-04T19:10:10",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/?p=12"
    },
    "modified": "2022-09-04T19:11:27",
    "modified_gmt": "2022-09-04T19:11:27",
    "slug": "foodscape-together",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/2022/09/04/foodscape-together/",
    "title": {
      "rendered": "Foodscape Together"
    },
    "content": {
      "rendered": "\u003Cdiv class=\"page\" title=\"Page 3\"\u003E\n\u003Cdiv class=\"section\"\u003E\n\u003Cdiv class=\"layoutArea\"\u003E\n\u003Cdiv class=\"column\"\u003E\n\u003Cp\u003E\u003Cstrong\u003EModule:\u003C/strong\u003E RVN1000 Engaging Communities in Sustainability\u003Cbr /\u003E\n\u003Cstrong\u003EPresenters:\u003C/strong\u003E Chan Zhi Ying/ Hugo Teo Wei Siang / Lee Wen Yi/ Tai Jia Xuan\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAbstract:\u003Cbr /\u003E\n\u003C/strong\u003EOur project is an initiative to develop a wider public outreach for the community activities organized by the Foodscape Collective. Despite their successful launch of community-based edible gardening as a sustainable initiative, they have not received much public attention or engagement. During our fieldwork and interactions with the Foodscape Collective, we identified that one of the key causes was a lack of an impactful publicity campaign. A secondary cause was a gap in communication between the Collective and the members of the community. As a result, residents from the surrounding neighbourhood are uninformed about the specific purpose and events held by the organizers. Our project intends to bridge this gap by designing an introductory display banner and the setting up of a space for communication by the organization with the residents. We hope that these would educate the public about Foodscape Collective’s mission and support their effort in creating a more sustainable environment.\u003C/p\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EModule: RVN1000 Engaging Communities in Sustainability Presenters: Chan Zhi Ying/ Hugo Teo Wei Siang / Lee Wen Yi/ Tai Jia Xuan Abstract: Our project is an initiative to develop a wider public outreach for the community activities organized by the Foodscape Collective. Despite their successful launch of community-based edible gardening as a sustainable initiative, they [&hellip;]\u003C/p\u003E\n",
      "protected": false
    },
    "author": 32564,
    "featured_media": 0,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "footnotes": ""
    },
    "categories": [1],
    "tags": [],
    "class_list": [
      "post-12",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-uncategorized"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/12",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/users/32564"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/comments?post=12"
        }
      ],
      "version-history": [
        {
          "count": 2,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/12/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 19,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/12/revisions/19"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/media?parent=12"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/categories?post=12"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/tags?post=12"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 9,
    "date": "2022-09-04T19:09:30",
    "date_gmt": "2022-09-04T19:09:30",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/?p=9"
    },
    "modified": "2022-09-04T19:11:17",
    "modified_gmt": "2022-09-04T19:11:17",
    "slug": "re-envisioning-labrador-park-in-the-greater-southern-waterfront",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/2022/09/04/re-envisioning-labrador-park-in-the-greater-southern-waterfront/",
    "title": {
      "rendered": "Re-envisioning Labrador Park in the Greater Southern Waterfront"
    },
    "content": {
      "rendered": "\u003Cdiv class=\"page\" title=\"Page 3\"\u003E\n\u003Cdiv class=\"section\"\u003E\n\u003Cdiv class=\"layoutArea\"\u003E\n\u003Cdiv class=\"column\"\u003E\n\u003Cp\u003E\u003Cstrong\u003EModule:\u003C/strong\u003E RVSS1000 Exploring Sense of Place\u003Cbr /\u003E\n\u003Cstrong\u003EPresenters:\u003C/strong\u003E Charis Chow Hui Ning/ Chloe Sau/ Khin Hnin Su/ Yanni Tan\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAbstract:\u003Cbr /\u003E\n\u003C/strong\u003EFollowing Tuan’s (1977) idea of space and place, Labrador Park is a place that through its materiality, meaning and practice, connects both nature and history. It prompts us to stop, pause and consider the physical surrounding and their meanings, thus creating a unique sense of place. Located at the heart of the Greater Southern Waterfront, the park holds a strong potential for redevelopment, where underutilised spaces can be repurposed to increase the vibrancy and usage of the area whilst maintaining and conserving the natural biodiversity. After conducting a thorough analysis of Labrador Park and its surroundings, our project proposal is centered on the concept of community building through nature, envisioned within a modern landscape; a family-centric location that plays on several biodiversity and cultural references while being firmly grounded in and enhancing Singapore’s natural and built heritage.\u003C/p\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EModule: RVSS1000 Exploring Sense of Place Presenters: Charis Chow Hui Ning/ Chloe Sau/ Khin Hnin Su/ Yanni Tan Abstract: Following Tuan’s (1977) idea of space and place, Labrador Park is a place that through its materiality, meaning and practice, connects both nature and history. It prompts us to stop, pause and consider the physical surrounding [&hellip;]\u003C/p\u003E\n",
      "protected": false
    },
    "author": 32564,
    "featured_media": 0,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "footnotes": ""
    },
    "categories": [1],
    "tags": [],
    "class_list": [
      "post-9",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-uncategorized"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/9",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/users/32564"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/comments?post=9"
        }
      ],
      "version-history": [
        {
          "count": 2,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/9/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 18,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/9/revisions/18"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/media?parent=9"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/categories?post=9"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/tags?post=9"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 7,
    "date": "2022-09-04T19:09:00",
    "date_gmt": "2022-09-04T19:09:00",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/?p=7"
    },
    "modified": "2022-09-04T19:11:09",
    "modified_gmt": "2022-09-04T19:11:09",
    "slug": "no-box-no-go",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/2022/09/04/no-box-no-go/",
    "title": {
      "rendered": "No Box No Go"
    },
    "content": {
      "rendered": "\u003Cdiv class=\"page\" title=\"Page 2\"\u003E\n\u003Cdiv class=\"section\"\u003E\n\u003Cdiv class=\"layoutArea\"\u003E\n\u003Cdiv class=\"column\"\u003E\n\u003Cp\u003E\u003Cstrong\u003EModule:\u003C/strong\u003E RVN1000 Engaging Communities in Sustainability\u003Cbr /\u003E\n\u003Cstrong\u003EPresenters:\u003C/strong\u003E Aristia Ho Zhen Yi/Hor Jia Wei/Javier Chia Yi Xian/Lim Siew Ping\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAbstract:\u003Cbr /\u003E\n\u003C/strong\u003EDuring the trash sorting activity for the RVN1000 field trip, our group discovered that the Grab-and-Go stall in the RVRC Dining Hall produces a significant amount of waste from single-use disposables. By dispensing food and drinks in single-use cups, brown paper bags and juice cartons, this stall directly contradicted the sustainability ethos espoused by RVRC. Hence, we decided to address this issue by proposing to eliminate packaging waste generated by the grab-and-go stall, thus drastically reducing the volume of single-use disposables in RVRC, which aligns with the NUS Zero Waste goal of eliminating single-use disposables by 2025. After carefully considering various dimensions of project feasibility, we conclude that this goal can be achieved in RVRC. We have been in discussions with various NUS and college stakeholders, including the Dining Hall Management Team, to identify a sustainable approach that would complement the needs of the RVRC residents as well. Our final goal is to bring about real behavioral shifts in the RVRC residential community.\u003C/p\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EModule: RVN1000 Engaging Communities in Sustainability Presenters: Aristia Ho Zhen Yi/Hor Jia Wei/Javier Chia Yi Xian/Lim Siew Ping Abstract: During the trash sorting activity for the RVN1000 field trip, our group discovered that the Grab-and-Go stall in the RVRC Dining Hall produces a significant amount of waste from single-use disposables. By dispensing food and drinks [&hellip;]\u003C/p\u003E\n",
      "protected": false
    },
    "author": 32564,
    "featured_media": 0,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "footnotes": ""
    },
    "categories": [1],
    "tags": [],
    "class_list": [
      "post-7",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-uncategorized"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/7",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/users/32564"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/comments?post=7"
        }
      ],
      "version-history": [
        {
          "count": 3,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/7/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 17,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/7/revisions/17"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/media?parent=7"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/categories?post=7"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/tags?post=7"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 5,
    "date": "2022-09-04T19:08:27",
    "date_gmt": "2022-09-04T19:08:27",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/?p=5"
    },
    "modified": "2022-09-04T19:10:56",
    "modified_gmt": "2022-09-04T19:10:56",
    "slug": "chinas-working-culture-key-aspects-and-differences-with-singaporean-culture",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/2022/09/04/chinas-working-culture-key-aspects-and-differences-with-singaporean-culture/",
    "title": {
      "rendered": "China&#8217;s Working Culture &#8211; Key Aspects and Differences with Singaporean Culture"
    },
    "content": {
      "rendered": "\u003Cdiv class=\"page\" title=\"Page 2\"\u003E\n\u003Cdiv class=\"section\"\u003E\n\u003Cdiv class=\"layoutArea\"\u003E\n\u003Cdiv class=\"column\"\u003E\n\u003Cp\u003E\u003Cstrong\u003EModule:\u003C/strong\u003E RVC1000 How in the world do we get along?\u003Cbr /\u003E\n\u003Cstrong\u003EPresenters:\u003C/strong\u003E Jeff Hong Zhi Yang/ Jheong Rong Yan/ Kiran Raj/ Qiu Jiasheng Jason/ Zsigmond Poh Kaiyou\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAbstract:\u003Cbr /\u003E\n\u003C/strong\u003EChina is Singapore’s largest trading partner. Due to this tight-knit business relationship between Singapore and China, we believe that it is important for Singaporeans hoping to work in Chinese companies to understand the key aspects of China’s corporate culture. Our project aims to discuss the significance and impact of Chinese culture in a workplace context. The project also compares and contrasts the workplace culture between the two countries – China and Singapore. We find that while China’s working culture is similar to Singapore’s in some areas, we also identify several crucial differences that may result in potential misunderstandings in the workplace. Using a carefully designed interactive session, we hope to allow participants to experience and understand key elements of Chinese working culture. Lastly, we propose strategies using David Livermore’s four-factor model of cultural intelligence that could help Singaporeans work effectively in a Chinese workplace setting.\u003C/p\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EModule: RVC1000 How in the world do we get along? Presenters: Jeff Hong Zhi Yang/ Jheong Rong Yan/ Kiran Raj/ Qiu Jiasheng Jason/ Zsigmond Poh Kaiyou Abstract: China is Singapore’s largest trading partner. Due to this tight-knit business relationship between Singapore and China, we believe that it is important for Singaporeans hoping to work in [&hellip;]\u003C/p\u003E\n",
      "protected": false
    },
    "author": 32564,
    "featured_media": 0,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "footnotes": ""
    },
    "categories": [1],
    "tags": [],
    "class_list": [
      "post-5",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-uncategorized"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/5",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/users/32564"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/comments?post=5"
        }
      ],
      "version-history": [
        {
          "count": 2,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/5/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 16,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/posts/5/revisions/16"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/media?parent=5"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/categories?post=5"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic1/wp-json/wp/v2/tags?post=5"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  }
];

export default thematic1;